import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { ACTIVE_STATUSES } from "@meeting-notes/shared";
import { useApi } from "../lib/api";
import { StatusChip } from "../components/StatusChip";

export function MeetingsPage() {
  const api = useApi();
  const q = useQuery({
    queryKey: ["meetings"],
    queryFn: () => api.listMeetings(),
    refetchInterval: (query) => (query.state.data?.items.some((m) => ACTIVE_STATUSES.includes(m.status)) ? 8_000 : false),
  });
  return (
    <div className="px-4 pt-4">
      <header className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">회의</h1>
        <Link to="/upload" className="tap rounded-full bg-indigo-500 px-4 py-2 text-sm font-semibold">+ 업로드</Link>
      </header>
      {q.isLoading && <p className="text-slate-400">불러오는 중…</p>}
      {q.error && <p className="text-red-300 text-sm">{String((q.error as Error).message)}</p>}
      {q.data && q.data.items.length === 0 && (
        <div className="mt-16 text-center text-slate-400">
          <div className="text-4xl mb-3">🗂️</div>
          <p>아직 회의가 없습니다.</p>
          <p className="text-sm">오른쪽 위 업로드로 mp3를 올려 보세요.</p>
        </div>
      )}
      <ul className="space-y-3">
        {q.data?.items.map((m) => (
          <li key={m.meetingId}>
            <Link to={`/meetings/${m.meetingId}`} className="tap block rounded-2xl bg-slate-900 border border-slate-800 p-4 active:bg-slate-800">
              <div className="flex items-start justify-between gap-3">
                <h2 className="font-semibold leading-snug">{m.title}</h2>
                <StatusChip status={m.status} />
              </div>
              <p className="mt-1 text-xs text-slate-400">
                {new Date(m.createdAt).toLocaleString("ko-KR")}
                {m.durationSec ? ` · ${Math.round(m.durationSec / 60)}분` : ""}
                {m.speakerCount ? ` · 화자 ${m.speakerCount}명` : ""}
              </p>
              {m.error && <p className="mt-1 text-xs text-red-300 line-clamp-2">{m.error}</p>}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
